<template lang="">
	<div class="mt-8 push-web-responsive-note">
    <div>
      <v-btn
        v-if="!loading"
        class="pa-5 my-11 b"
        height="50px"
        outlined
        @click="openModalList">
        <img class="pr-3" src="../../../../static/images/add-circle-black.svg"/><span class="ff">Nova lista</span>
      </v-btn>
    </div>

    <ValidationObserver v-slot="{ invalid }">
      <v-card class="filter--container d-flex">
        <ValidationProvider
          class="form-group"
          rules="required"
          v-slot="{ errors }"
          >
          <span class="d-flex flex-row inputMessageFilter">
          <input
              v-model="search"
              type="text"
              placeholder="Nome da lista"
              class="inputWidth"
          >
          </span>
        </ValidationProvider>

        <div class="button-wrapper d-flex justify-space-between">
          <button
            @click="filterList"
            class="mr-5"
            :disabled="invalid"
          >
            <clip-loader
              v-if="loading"
              :loading="loading"
              color="var(--white)"
              size="22px"
            />
            <div
              v-if="!loading"
              class="button-wrapper--text"
              >
              <img src="../../../../static/images/search.svg">
              Buscar
            </div>
          </button>

          <button
            @click="clearForm"
            style="background: var(--white); border: 1px solid grey; color: var(--dark-grey)"
          >

            <clip-loader
              v-if="loadingClear"
              :loading="loadingClear"
              color="var(--black)"
              size="22px"
            />
            <div
              v-if="!loadingClear"
              class="button-wrapper--text"
              >
              <img src="../../../../static/images/load.svg">
              Limpar
            </div>
          </button>
        </div>
      </v-card>
    </ValidationObserver>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="smsLists"
        :range="7"
        class="elevation-2 fs-16 teste"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
        @page-count="pageCount = $event"
        loader-height
      >

        <template v-slot:item.updated_at="{item}">
          {{new Date(item.updated_at).toLocaleDateString()}}
        </template>

        <template v-slot:item.is_active="{item}">
          <status-toggle
            v-model="item.is_active"
            :item="item"
            :item-status="item.is_active"
            item-type="is_active"
            :updateAction="updateSmsList"
            :disableAction="disableSmsList"
          />
        </template>
        <template v-slot></template>
        <template v-slot:item.actions="{item}">
          <button @click="setSmsList(item)" class="b-4 ma-2 editButtonSmsList">
            <img src="../../../../static/images/edit.svg"/>
          </button>
        </template>
        <template v-slot:no-data>
          <span>Registro não encontrado</span>
        </template>
			</v-data-table>
		</v-card>

    <v-card class="mt-8">
			<div
				v-if="!loading"
				class="list-footer">
				<span></span>
				<v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="7"
          color="#F0F1F3"
        ></v-pagination>
				<div class="goToPage">
					<span class="goToPage--text">
						Ir para página
					</span>
					<label>
						<input
							v-model="goToPage"
							type="text"
						>
						<button
							@click="goToPageRequest"
						>
							<div
								class="button-wrapper--text">
								<i class="iconStyle icon-arrow-right d-flex justify-center align-center"></i>
							</div>
						</button>
						<span
							:class="showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'"
							class="goToPage--helptext"
						>
							A página deve estar entre 1 e {{pageCount}}
						</span>
					</label>
				</div>
			</div>
		</v-card>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      overlay
      temporary
      right
      width="620"
      height="100vh"
      style="background: var(--grey-day-010)"
    >
      <NewShippingForm v-on:close="drawer = false"/>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="drawerEdit"
      fixed
      overlay
      temporary
      right
      width="620"
      height="100vh"
      style="background: var(--grey-day-010)"
    >
      <EditShippingForm v-on:close="drawerEdit = false"/>
    </v-navigation-drawer>
  </div>
</template>
<script>
// Libs
import { mapActions, mapMutations, mapState } from "vuex";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { ValidationProvider, ValidationObserver } from 'vee-validate'

// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";


// Token
import VueCookies from "vue-cookies";

// Components
import NewShippingForm  from '@/components/Contents/ScheduleWeb/NewShippingForm';
import EditShippingForm  from '@/components/Contents/ScheduleWeb/EditShippingForm'
import StatusToggle from '@/components/StatusToggle.vue'
//mixins
import date from '../../../mixins/date'
// import toaster from '../../../mixins/toaster'

export default {
  mixins: [date],
  components: {
    ValidationProvider,
    ValidationObserver,

    ClipLoader,
    NewShippingForm,
    EditShippingForm,
    StatusToggle,
  },
  data () {
		return {
			goToPage: 1,
      showGoToPageHelpText: false,
      disabledGoTo: false,
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      success: false,
      notification: false,
      drawer: false,
      drawerEdit: false,
      search: '',
      hasBorder: false,
      loadingClear: false,
		}
  },
	async created () {
    const token = VueCookies.get('jwt-login')
    this.setLoading(true)
    try {
      await this.getGroups({
        page: 0,
        size: 700,
        token: token
      })
      this.setLoading(false)
    } catch (error) {
      console.error(error)
      this.toaster(
        'Erro na requisição',
        "warning",
        true
      );
    }
  },
  checkStatus() {
      return this.item.is_active !== null && this.item.is_active !== undefined
    },
  computed: {
    ...mapState('MessageForm', [
      'smsLists',
    ]),
    ...mapState('MessageForm', {
      items: 'items',
      loading: 'loading',
      size: 'size',
      pagination: 'pagination'
    }),
    headers () {
      return [
        { value: 'group_name', text: 'Nome' ,class: 'header-table grey lighten-2'},
        { value: 'id_push_moe', text: 'ID Push Moe' ,class: 'header-table grey lighten-2'},
        { value: 'updated_at', text: 'Atualizado em' ,class: 'header-table grey lighten-2'},
        { value: 'is_active', text: 'Status' ,class: 'header-table grey lighten-2'},
        { value: 'actions', text: 'Edit', class:'header-table grey lighten-2' }
      ]
    },
  },
  methods: {
    ...mapActions('MessageForm', [
      'getGroups',
      'getSmsLists',
      'getMessageForm',
      'updateSmsList',
      'disableSmsList',
      'getFilteredSmsList'
    ]),
    openModalList () {
      this.drawer = true
    },
    setSmsList (itemRow) {
      this.drawerEdit = true
       this.setSmsListToEdit(itemRow)
    },
    ...mapMutations('Communication', {
      setLoading: 'SET_LOADING'
    }),
    ...mapMutations('MessageForm', {
      setSmsListToEdit: 'SET_SMS_LIST_TO_EDIT',
      setSmsFilter: 'SET_SMSLIST_FILTER',
    }),
		async goToPageRequest () {
      this.page = +this.goToPage
    },
    async filterList () {
      const token = VueCookies.get('jwt-login')
      this.setLoading(true)
    try {
      await this.getFilteredSmsList({
        page: 0,
        size: 700,
        listName: this.search,
        token: token
      })
      this.setLoading(false)
    } catch (error) {
      console.error(error)
      this.toaster(
        'Erro na requisição',
        "warning",
        true
      );
    }
    },
    async clearForm () {
      this.search = ''
      this.setSmsFilter('')
      this.loadingClear = true
      const token = VueCookies.get('jwt-login')
      this.goToPage = 1
      this.page = 1
      this.loadingClear = false
      await this.getGroups({
        page: 0,
        size: 700,
        token: token
      })
    },
  },
	watch: {
    'goToPage' () {
      if (this.goToPage < 1 || this.goToPage > this.pageCount) {
        this.showGoToPageHelpText = true
        this.disabledGoTo = true
      } else {
        this.showGoToPageHelpText = false
        this.disabledGoTo = false
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.inputMessageFilter {
  height: 48px;
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  padding: 7px;
  margin-right: 20px;
}
  .inputWidth {
      width: 350px;
    }

.vs__clear {
  display: none;
}

.push-app__select {
  width: 190px;
}

.push-web-responsive-note {
  width: 1224px;

  .buttons_action {
    display: flex;
    justify-content: flex-end;
  }

  .vs__selected-options {
    width: 180px;
    padding-right: 3px;
  }

  .v-expansion-panel-header {
    padding: 7px 10px 7px 3px;
  }
  .mx-input {
    display: flex;
    height: 44px;
    border: none;
    outline: none;
  }

  .mx-input-wrapper {
    margin-top: -8px;
  }

  .filter--container {
    background: var(--white);
    border-radius: 4px;
    margin-bottom: 3.125rem;
    padding: 1.375rem;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    height: 88px;

    .inputFilter {
      border: 2px solid var(--grey-day-030);
      justify-content: space-between;
      height: 48px;
      padding: 7px;
      margin-right: 20px;
      border-radius: 4px;
      padding-left: 0;
      border-radius: 4px !important;
      font-family: "DM Sans Regular", sans-serif;

      .mx-input-wrapper {
        justify-content: center;
        padding-left: 0;
        font-family: "DM Sans Regular", sans-serif;
      }

      input {
        width: 100% !important;
        padding-left: 10px;
        font-family: "DM Sans Regular", sans-serif;
      }

      img {
        opacity: 0.5;
      }
    }

    label:focus-within {
      border: 2px solid var(--grey);
    }
    .button-wrapper {
      display: flex;
      justify-content: flex-end;

      &--text {
        display: flex;
        align-items: center;
      }

      button {
        background: var(--dark-red);
        border: none;
        border-radius: 4px;
        color: var(--white);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: var(--dm-sans-medium);
        font-size: 1rem;
        padding: 0.875rem;
        min-height: 48px;
        width: 130px;

        img {
          margin-right: 0.875rem;
        }
      }

      button:disabled {
        background: #dddddd;
        cursor: not-allowed;
      }
    }
  }

  .b-4 {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
  }

  .h-48 {
    height: 48px;
  }

  .vs__dropdown-toggle {
    border: none !important;
  }

  .vs__search {
    display: flex;
    align-items: center;
    padding: 7px;
    color: var(--dark-grey);
  }

  .list-footer {
    background: var(--white);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 2.625rem;
    margin: 80px 0 10px 0;
    height: 64px;
  }

  .v-pagination__navigation,
  .v-pagination__item {
    border: none;
    box-shadow: none;
  }

  .goToPage {
    &--text {
      font-size: 14px;
      font-family: var(--dm-sans-regular);
      color: var(--dark-grey);
      margin-right: 20px;
    }

    label {
      border: 2px solid var(--grey-day-030);
      background: var(--white);
      border-radius: 4px;
      box-sizing: border-box;
      max-width: 84px;
      width: 80px;
      padding: 10px;
      position: relative;

      input {
        width: 54px;
        font-size: 1rem;
        color: var(--grey);
        font-family: var(--dm-sans-regular);
      }

      button {
        position: absolute;
        border-radius: 50%;
        border: none;
        padding: 0;
        top: 11px;
        right: 8px;
        background: var(--grey);
        cursor: pointer;

        i {
          color: var(--white);
          font-size: 1.25rem;
        }
      }

      button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    &--helptext {
      font-family: var(--dm-sans-regular);
      position: absolute;
      font-size: 12px;
      width: 120px;
      text-align: center;
      top: -55px;
      left: -24px;
      background: var(--dark-red);
      padding: 8px;
      color: var(--light-grey);
      border-radius: 4px;
    }

    .--hide-helptext {
      display: none;
    }

    .--show-helptext {
      display: block;
    }
  }

  .iconStyle {
    width: 20px;
    height: 20px;
    background: transparent;
  }

  .borderL {
    height: 49px;
    max-width: 3px !important;
    width: 13px;
    background-color: var(--blue);
    margin: 0 3px;
    position: absolute;
  }

  .v-expansion-panel--active .borderL {
    height: initial;
    // max-width: 3px !important;
    transition: 0.3s;
    width: 4px;
    background-color: var(--blue);
    margin: 0px 3px;
    position: absolute;
    top: 9px;
    bottom: 9px;
  }
}

.v-application .widthResponsive {
  width: 10%;
  margin-left: 50px;
}

.editButtonSmsList {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 1377px) {
  .responsiveItemName {
    display: flex;
    align-items: flex-start;
  }

  .v-application {
    .widthResponsive {
      margin-top: 0;
    }

    .push-web-responsive-note {
      width: 830px;

      .filter--container {
        height: initial;

        &.d-flex {
          display: grid !important;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
        }

        .button-wrapper {
          grid-row: 4;
          grid-column: 1 / -1;
          justify-self: flex-start;
        }
        .inputFilter {
          width: 100%;

          &:nth-child(1) {
            grid-row: 1;
            grid-column: 1 / -1;
          }

          &:nth-child(2) {
            grid-row: 2;
            grid-column: 1 / -1;
          }

          &:nth-child(3) {
            grid-row: 3;
          }

          &:nth-child(4) {
            grid-row: 3;
          }

          &.mx-datepicker:nth-child(3) {
            // margin-bottom: -48px;
            // width: 48%;
          }
        }
      }

      .v-expansion-panel--active {
        .borderL {
          height: 320px;
        }
      }
    }
  }

  .push-web-responsive-note {
    .filter--container {
      .mx-datepicker:nth-child(4) {
        grid-column: 2;
        grid-row: 3;
      }
    }

    .responsive-note {
      max-width: 55%;
      align-self: self-start;
      margin-left: 27px !important;
    }

    .widthResponsive {
      width: 200px;
    }
    .inputFilter {
      width: 114px;
    }
    .imgResponsive {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/List.vue